// Mock data pentru blogurile existente - vor fi combinate cu cele migrate din site-ul vechi
export const blogPosts = [
    {
        id: 1,
        slug: 'importanta-sanatatii-mentale-in-viata-de-zi-cu-zi',
        title: 'Importanța sănătății mentale în viața de zi cu zi',
        excerpt: 'Sănătatea mentală este la fel de importantă ca și cea fizică. Să explorăm cum putem să ne îngrijim de ea în fiecare zi.',
        metaDescription: 'Descoperă importanța sănătății mentale și cum să o întreții zilnic pentru o viață echilibrată și împlinită.',
        content: `
            <p>Sănătatea mentală este fundamentul unei vieți împlinite și echilibrate. În lumea modernă, presiunile zilnice pot afecta starea noastră emoțională și psihologică în moduri pe care uneori nu le observăm imediat.</p>
            
            <h2>Ce înseamnă sănătatea mentală?</h2>
            <p>Sănătatea mentală nu înseamnă doar absența bolilor psihice. Ea reprezintă starea de bine emoțional, psihologic și social care ne permite să:</p>
            <ul>
                <li>Gestionăm stresul în mod sănătos</li>
                <li>Menținem relații semnificative</li>
                <li>Luăm decizii bune</li>
                <li>Ne adaptăm la schimbări</li>
            </ul>
            
            <h2>Semnale că sănătatea mentală necesită atenție</h2>
            <p>Este important să recunoaștem semnalele care indică faptul că starea noastră mentală are nevoie de îngrijire:</p>
            <ul>
                <li>Schimbări în pofta de mâncare sau somnul</li>
                <li>Sentimente persistente de tristețe sau anxietate</li>
                <li>Dificultăți în concentrare</li>
                <li>Retragerea din activitățile sociale</li>
                <li>Schimbări extreme de dispoziție</li>
            </ul>
            
            <h2>Strategii pentru o sănătate mentală optimă</h2>
            <p>Există multe moduri prin care putem să ne îngrijim de sănătatea mentală:</p>
            
            <h3>1. Practicarea mindfulness-ului</h3>
            <p>Mindfulness-ul ne ajută să fim prezenți în momentul actual și să observăm gândurile și emoțiile noastre fără judecată.</p>
            
            <h3>2. Exercițiul fizic regulat</h3>
            <p>Activitatea fizică eliberează endorfine, care îmbunătățesc dispoziția și reduc stresul.</p>
            
            <h3>3. Menținerea conexiunilor sociale</h3>
            <p>Relațiile sănătoase sunt esențiale pentru bunăstarea emoțională. Nu ezita să ceri ajutor când ai nevoie.</p>
            
            <h3>4. Stabilirea limitelor</h3>
            <p>Învață să spui "nu" și să îți protejezi timpul și energia pentru lucrurile cu adevărat importante.</p>
            
            <h2>Când să ceri ajutor profesional</h2>
            <p>Dacă simți că nu poți gestiona singur provocările cu care te confrunți, este timpul să apelezi la un profesionist. Terapia poate oferi:</p>
            <ul>
                <li>Instrumente pentru gestionarea stresului și anxietății</li>
                <li>Perspective noi asupra problemelor</li>
                <li>Un spațiu sigur pentru explorarea emoțiilor</li>
                <li>Strategii personalizate pentru situația ta unică</li>
            </ul>
            
            <p>Îngrijirea sănătății mentale este o investiție în tine și în calitatea vieții tale. Nu este un semn de slăbiciune să ceri ajutor - este un act de curaj și autoîngrijire.</p>
        `,
        imageUrl: '/images/mental-health.jpg',
        publishDate: '2024-01-15',
        readingTime: 8,
        category: 'Sănătate Mentală',
        tags: ['Sănătate Mentală', 'Autoîngrijire', 'Mindfulness']
    },
    {
        id: 2,
        slug: 'gestionarea-anxietatii-tehnici-practice',
        title: 'Gestionarea anxietății: tehnici practice pentru liniște',
        excerpt: 'Anxietatea poate fi copleșitoare, dar există tehnici dovedite științific care te pot ajuta să o gestionezi eficient.',
        metaDescription: 'Învață tehnici practice și dovedite științific pentru gestionarea anxietății și găsirea liniștii interioare.',
        content: `
            <p>Anxietatea este una dintre cele mai comune provocări emoționale cu care ne confruntăm în viața modernă. Deși poate părea copleșitoare, există multe tehnici eficiente care ne pot ajuta să o gestionăm.</p>
            
            <h2>Înțelegerea anxietății</h2>
            <p>Anxietatea este o reacție naturală la stres, dar când devine intensă sau persistentă, poate interfera cu viața zilnică. Simptomele pot include:</p>
            <ul>
                <li>Bătăi rapide ale inimii</li>
                <li>Respirație scurtă</li>
                <li>Tensiune musculară</li>
                <li>Gânduri repetitive de îngrijorare</li>
                <li>Dificultăți de concentrare</li>
            </ul>
            
            <h2>Tehnici de respirație pentru calmarea imediată</h2>
            
            <h3>Respirația 4-7-8</h3>
            <p>Această tehnică simplă poate calma rapid sistemul nervos:</p>
            <ol>
                <li>Inspiră prin nas timp de 4 secunde</li>
                <li>Ține respirația timp de 7 secunde</li>
                <li>Expiră prin gură timp de 8 secunde</li>
                <li>Repetă de 3-4 ori</li>
            </ol>
            
            <h3>Respirația diafragmatică</h3>
            <p>Pune o mână pe piept și una pe abdomen. Respiră încet prin nas, asigurându-te că mâna de pe abdomen se ridică mai mult decât cea de pe piept.</p>
            
            <h2>Tehnica de grounding 5-4-3-2-1</h2>
            <p>Această tehnică te ajută să te întoarci în momentul prezent:</p>
            <ul>
                <li>5 lucruri pe care le poți vedea</li>
                <li>4 lucruri pe care le poți atinge</li>
                <li>3 lucruri pe care le poți auzi</li>
                <li>2 lucruri pe care le poți mirosi</li>
                <li>1 lucru pe care îl poți gusta</li>
            </ul>
            
            <h2>Reevaluarea gândurilor anxioase</h2>
            <p>Anxietatea adesea implică gânduri catastrofice. Întreabă-te:</p>
            <ul>
                <li>Este acest gând realist?</li>
                <li>Care este cel mai rău lucru care s-ar putea întâmpla?</li>
                <li>Cum aș sfătui un prieten în aceeași situație?</li>
                <li>Ce dovezi am pentru și împotriva acestui gând?</li>
            </ul>
            
            <h2>Activități pentru reducerea anxietății pe termen lung</h2>
            
            <h3>Exercițiul fizic</h3>
            <p>Activitatea fizică regulată reduce nivelurile de cortizol și eliberează endorfine naturale.</p>
            
            <h3>Meditația și mindfulness</h3>
            <p>Doar 10 minute de meditație zilnică pot reduce semnificativ nivelurile de anxietate.</p>
            
            <h3>Jurnalul de anxietate</h3>
            <p>Scrie despre gândurile și emoțiile tale pentru a identifica tiparele și factorii declanșatori.</p>
            
            <h2>Când să ceri ajutor profesional</h2>
            <p>Dacă anxietatea interferează cu activitățile zilnice, relațiile sau munca, este important să consulți un specialist. Terapia cognitiv-comportamentală este deosebit de eficientă pentru anxietate.</p>
            
            <p>Amintește-ți: gestionarea anxietății este o abilitate care se învață și se îmbunătățește cu practica. Fii răbdător cu tine și celebrează progresul, oricât de mic ar fi.</p>
        `,
        imageUrl: '/images/anxiety-management.jpg',
        publishDate: '2024-01-08',
        readingTime: 10,
        category: 'Anxietate',
        tags: ['Anxietate', 'Tehnici de relaxare', 'Mindfulness', 'Respirație']
    },
    {
        id: 3,
        slug: 'comunicarea-eficienta-in-cuplu',
        title: 'Comunicarea eficientă în cuplu: cheia relațiilor sănătoase',
        excerpt: 'O comunicare deschisă și empatică poate transforma relația de cuplu și poate preveni multe conflicte.',
        metaDescription: 'Descoperă tehnicile de comunicare eficientă care pot îmbunătăți relația de cuplu și preveni conflictele.',
        content: `
            <p>Comunicarea este fundamentul oricărei relații sănătoase, iar în cuplu aceasta devine și mai crucială. Mulți dintre conflictele pe care le experimentăm în relații pot fi prevenite sau rezolvate prin îmbunătățirea modului în care comunicăm.</p>
            
            <h2>Barierele comune în comunicare</h2>
            <p>Înainte de a învăța să comunicăm mai bine, să identificăm ce ne împiedică:</p>
            <ul>
                <li>Ascultarea pentru a răspunde, nu pentru a înțelege</li>
                <li>Presupuneri despre ce gândește partenerul</li>
                <li>Comunicarea în momente de emoție intensă</li>
                <li>Evitarea discuțiilor dificile</li>
                <li>Criticarea în loc de exprimarea nevoilor</li>
            </ul>
            
            <h2>Principiile comunicării eficiente</h2>
            
            <h3>1. Ascultarea activă</h3>
            <p>Ascultarea activă înseamnă să fii complet prezent în conversație:</p>
            <ul>
                <li>Pune telefonul deoparte</li>
                <li>Menține contactul vizual</li>
                <li>Parafrazează ce ai înțeles</li>
                <li>Pune întrebări pentru clarificare</li>
            </ul>
            
            <h3>2. Exprimarea cu "eu"</h3>
            <p>În loc să spui "Tu întotdeauna...", încearcă:</p>
            <p><em>"Eu mă simt... când... pentru că..."</em></p>
            <p>Exemplu: "Eu mă simt neglijată când ajungi târziu acasă fără să mă anunți pentru că îmi fac griji pentru tine."</p>
            
            <h3>3. Timing-ul potrivit</h3>
            <p>Alege momentele potrivite pentru discuții importante:</p>
            <ul>
                <li>Când ambii sunteți relaxați</li>
                <li>Fără distrageri externe</li>
                <li>Nu când unul dintre voi este stresat sau obosit</li>
            </ul>
            
            <h2>Gestionarea conflictelor constructiv</h2>
            
            <h3>Regula "pauzei"</h3>
            <p>Când tensiunile escaladează, luați o pauză de 20-30 de minute pentru a vă calma. Cortizolul (hormonul stresului) are nevoie de timp să scadă.</p>
            
            <h3>Concentrarea pe soluții</h3>
            <p>În loc să vă fixați pe problemă, întrebați-vă:</p>
            <ul>
                <li>Ce vrem să realizăm din această discuție?</li>
                <li>Cum putem rezolva această situație împreună?</li>
                <li>Ce compromise suntem dispuși să facem?</li>
            </ul>
            
            <h2>Exprimarea afecțiunii și aprecierii</h2>
            <p>Comunicarea nu este doar despre rezolvarea problemelor. Exprimarea regulată a dragostei și aprecierii consolidează legătura:</p>
            <ul>
                <li>Spune zilnic ceva ce apreciezi la partenerul tău</li>
                <li>Exprimă-ți dragostea în diferite moduri</li>
                <li>Recunoaște eforturile partenerului, oricât de mici</li>
            </ul>
            
            <h2>Limbajele dragostei</h2>
            <p>Fiecare persoană își exprimă și receptează dragostea diferit:</p>
            <ul>
                <li><strong>Cuvinte de afirmare:</strong> complimente și încurajări</li>
                <li><strong>Timp de calitate:</strong> atenție neîmpărțită</li>
                <li><strong>Cadouri:</strong> gesturi gândite cu grijă</li>
                <li><strong>Acte de serviciu:</strong> ajutor cu sarcinile</li>
                <li><strong>Contact fizic:</strong> îmbrățișări, atingeri</li>
            </ul>
            
            <h2>Crearea ritualurilor de conectare</h2>
            <p>Stabiliți momente regulate pentru comunicare:</p>
            <ul>
                <li>10 minute în fiecare seară pentru a discuta despre zi</li>
                <li>Un check-in săptămânal despre relație</li>
                <li>Cine lunare fără telefoane</li>
            </ul>
            
            <h2>Când să apelați la terapia de cuplu</h2>
            <p>Dacă vă confruntați persistent cu:</p>
            <ul>
                <li>Certuri care se repetă fără rezolvare</li>
                <li>Sentimente de înstrăinare</li>
                <li>Probleme de încredere</li>
                <li>Comunicare toxică</li>
            </ul>
            <p>Un terapeut de cuplu poate oferi instrumentele și perspectiva neutră necesare pentru a îmbunătăți comunicarea și relația.</p>
            
            <p>Comunicarea eficientă este o abilitate care se dezvoltă cu timpul și practica. Investiția în îmbunătățirea comunicării este o investiție în fericirea și longevitatea relației voastre.</p>
        `,
        imageUrl: '/images/couple-communication.jpg',
        publishDate: '2024-01-01',
        readingTime: 12,
        category: 'Relații',
        tags: ['Relații', 'Comunicare', 'Cuplu', 'Conflict']
    }
];
